export default __webpack_public_path__ + "static/media/Monkey2.85013945.png";